/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcJpmamV1NetOrderEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_JPMAM_V1_NET_ORDER_EVENT_ENTITY_NAME = 'exc.jpmam.v1.NetOrderEvent';
export const excJpmamV1NetOrderEventEntity = new schema.Entity<ExcJpmamV1NetOrderEvent>(EXC_JPMAM_V1_NET_ORDER_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcJpmamV1NetOrderEvent) => `${entity.metadata?.eventId}` });

